import Error from 'Components/UI_Library/Icons/NewIconSet/Error.png';
import Info from 'Components/UI_Library/Icons/NewIconSet/Info.png';
import Success from 'Components/UI_Library/Icons/NewIconSet/Success.png';
import Warning from 'Components/UI_Library/Icons/Warning.png';

export type NotificationType = 'success' | 'info' | 'error' | 'danger' | 'warning' | 'attention';

export const getIcon = (type: NotificationType | string): string => {
    switch (type) {
        case 'danger':
        case 'error':
        case 'attention':
            return Error;
        case 'success':
            return Success;
        case 'warning':
            return Warning;
        case 'info':
        default:
            return Info;
    }
};
